module.exports = __webpack_public_path__ + "static/media/ReitzVessel.bef8f63d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Reitz/ReitzVessel.jpg
// module id = 5766
// module chunks = 0